export function noop() {
  // Intentionally empty
}
